import React, { Component } from 'react';
import { DropTarget, DragSource } from 'react-dnd'
import AddJumpers from './modals/addJumpers'
import CancelJump from './modals/cancelJump'
import RemovableJumper from './modals/removableJumper'
import EditableFunJumper from './modals/editableFunJumper'
import EditableJumpType from './modals/editableJumpType'
import EditableAltitude from './modals/editableAltitude'

import { Card, CardImg, CardText, CardBody, CardTitle, CardHeader, CardFooter, Row, Col, Button, } from 'reactstrap'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import RenderJumperTarget from './modals/RenderJumperTarget';
import loadsStore from '../../stores/loads-store';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import returnLoadSettings from '../helpers/returnLoadSettings';
import NestedFunJumpMenu from './NestedMenus';


const Types = {
    ITEM: 'JUMP'
};

const itemSource = {
    beginDrag(props) {
        //console.log('dragging');
        const item = props
        return item
    },
    endDrag(props, monitor, component) {
        //console.log('endrag')
        if (!monitor.didDrop()) {
            return;
        }
        //return props.handleJumperDrop(props)
        return props;
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}


class RenderFunJump extends Component {
    constructor() {
        super();
        this.state = {
            menu: false,
            optionMenu: false,
            optionSub: false,
            copyOptionSub: false,
            cutOptionSub: false
        }
    }

    handleCopyClick = (funJump = this.props.funJump, loadNum = this.props.loadNum, uid = -1000) => {
        this.setState({
            copyOptionSub: true
        })
        var payload = {};
        payload.jumperIds = funJump.jumpers.map(jumper => {
            return {
                jumperId: jumper._id,
                price: jumper.price,
                block: jumper.block,
                blockId: jumper.blockId,
                gearPrice: jumper.gearPrice,
                gearType: jumper.gearType,
                isLOing: jumper.isLOing,
                tracked: jumper.tracked
            }
        });
        payload.jumpType = funJump.jumpType;
        payload.gearRentals = funJump.gearRentals;
        payload.studentgearRentals = funJump.studentgearRentals;
        payload.sportgearRentals = funJump.sportgearRentals;
        payload.altitude = funJump.altitude;
        payload.copy = true;
        loadsStore.copied = true;
        loadsStore.cut = false;
        loadsStore.copyValue = payload;
        var element = document.getElementById(uid);
        // element.style.display = "none";
        if (uid !== -1000) {
            var element = document.getElementById(uid);
            element.style.display = "none";
        }

    }
    handleCutClick = (funJump = this.props.funJump, loadNum = this.props.loadNum, uid = "fun" + this.props.loadNum + "_" + this.props.jumpId, jumpId = this.props.jumpId) => {

        if (window.ENV?.disableRemoveAt8MinCall && this.props.timeRemaining < 480) {
            swal({
                title: "Warning",
                text: "cannot move with less than 8 min call",
                icon: "warning",
                dangerMode: false,
            })
        }
        else {
            this.setState({
                cutOptionSub: true
            })
            var payload = {};
            payload.jumperIds = funJump.jumpers.map(jumper => {
                return {
                    jumperId: jumper._id,
                    price: jumper.price,
                    block: jumper.block,
                    blockId: jumper.blockId,
                    gearPrice: jumper.gearPrice,
                    gearType: jumper.gearType,
                    isLOing: jumper.isLOing,
                    tracked: jumper.tracked
                }
            });
            payload.jumpType = funJump.jumpType;
            payload.gearRentals = funJump.gearRentals;

            payload.studentgearRentals = funJump.studentgearRentals;
            payload.sportgearRentals = funJump.sportgearRentals;

            payload.altitude = funJump.altitude;

            loadsStore.cut = true;
            loadsStore.cutValue = { loadNum, jumpId }
            loadsStore.copyValue = payload;
            // this.props.toggleToster(true, "Seleted")

            var element = document.getElementById(uid);
        }
    }

    // handleCutClick = (funJump, loadNum, uid, jumpId) => {
    //     // console.log('Copyclicked',funJump,loadNum);
    //     var payload = {};
    //     payload.jumperIds = funJump.jumpers.map(x => x._id);
    //     payload.jumpType = funJump.jumpType;
    //     payload.gearRentals = funJump.gearRentals;
    //     loadsStore.cut = true;
    //     loadsStore.cutValue = { loadNum, jumpId }
    //     // loadsStore.deleteJumpId = deleteJumpId
    //     loadsStore.copyValue = payload;
    //     var element = document.getElementById(uid);
    //     element.style.display = "none";
    // }
    handleCopyPasteClick = (loadNum) => {
        this.setState({
            optionMenu: !this.state.optionMenu,
            optionSub: false,
            copyOptionSub: false,
            cutOptionSub: false
        })
        var Value = loadsStore.copyValue;
        console.log("pasteclicked", loadNum, Value);

        loadsStore.createFunJump(loadNum, Value).then(d => {
            console.log("createFunJump in pasted", d);
            if (d) {
                if (loadsStore.cut) {
                    loadsStore.cut = false;
                    const { loadNum, jumpId } = loadsStore.cutValue;
                    loadsStore.cancelFunJump(loadNum, jumpId);
                }
            }
        });


    };

    componentWillMount() {
        document.querySelector('body').addEventListener("click", this.handleEventClick, false);
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.querySelector('body').removeEventListener("click", this.handleEventClick, false);
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        let id;
        if (document.querySelector('#copy-funJump-menu')) {
            id = document.querySelector('#copy-funJump-menu')
        } else {
            id = document.querySelector('#move-funJump-menu')
        }

        if (!domNode || !domNode.contains(event.target)) {
            if (this.state.optionMenu) {
                if (!id) {
                    this.setState({
                        optionMenu: false,
                        optionSub: false
                    });
                }
            }
        }
    }


    handleEventClick = () => {
        var divsToHide = document.getElementsByClassName("copyPanel");
        for (var i = 0; i < divsToHide.length; i++) {
            divsToHide[i].style.display = "none";
        }
    }

    handleClick = (e, uid, isCompleted, parentId) => {
        e.preventDefault();
        var divsToHide = document.getElementsByClassName("copyPanel");
        for (var i = 0; i < divsToHide.length; i++) {
            divsToHide[i].style.display = "none";
        }
        if (isCompleted) {
            var element = document.getElementById(uid);
            element.style.display = "block";
            var container = document.getElementById(parentId);

            var xPosition = e.clientX - container.getBoundingClientRect().left - (element.clientWidth / 2);
            var yPosition = (e.clientY - container.getBoundingClientRect().top - (element.clientHeight / 2));
            element.style.left = xPosition + "px";
            element.style.top = yPosition + "px";

            // setTimeout(() => {
            //     element.style.display = "none";
            // }, 10000)
        }
    }

    toggleOptions = () => {
        this.setState({
            optionMenu: !this.state.optionMenu
        })
    }

    handleDelete = (jumpId) => {
        if (window.ENV?.disableRemoveAt8MinCall && this.props.timeRemaining < 480) {
            swal({
                title: "Warning",
                text: "cannot move with less than 8 min call",
                icon: "warning",
                dangerMode: false,
            })
        }
        else {
            console.log("HANDLEDELET: ", jumpId);
            document.getElementById(jumpId).click();
        }
    }

    render() {
        console.log('rendering fun jump on load ' + this.props.loadNum);

        const { funJump, loadNum, timeRemaining, jumpId, disabled, jumperOptions, isDragging, connectDragSource, src, iscompleted, isClosed, isJumperRole, loadsToShow, fontSize, columnsPerGroup } = this.props;
        const opacity = isDragging ? 0 : 1;
        var uid = "fun" + loadNum + "_" + jumpId;
        var parentId = "funParent" + loadNum + "_" + jumpId;

        var IsEventEnable = this.props.iscompleted ? 'none' : '';
        var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';

        const jumpers = funJump.jumpers.map((jumper, index) => {

            if (jumper.firstname === "HOLD" && jumper.lastname === "HOLD") {
                return (
                    <ul className="jumper-load" key={"fun" + jumper._id + index}>
                        <li >
                            <EditableFunJumper editMode={true} type={"funjump"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={jumper} options={jumperOptions} />
                        </li>
                    </ul>
                )
            }
            else
                return (
                    // <li key={jumper._id} style={listStyle} >
                    <ul className="jumper-load" key={"fun" + jumper._id + index}>
                        <li >
                            <RemovableJumper loadNum={loadNum} jumpId={jumpId} jumper={jumper} />
                        </li>
                    </ul>
                );
        })
        const { settingsMoreThan4 } = returnLoadSettings(loadsToShow, columnsPerGroup, fontSize)
        return connectDragSource(
            <div style={{ opacity }} style={{ pointerEvents: IsdisplayOnly }}>
                {
                    iscompleted &&
                    <div className="react-contextmenu copyPanel" id={"fun" + loadNum + "_" + jumpId} style={{ marginBottom: '-38px', position: 'relative', width: '96px', display: 'none', zIndex: '9999' }}
                        onClick={() => this.handleCopyClick(funJump, loadNum, uid)}
                    >
                        <span className="react-contextmenu-item" >Copy Jump</span>
                    </div>
                }
                <div onContextMenu={(e) => this.handleClick(e, uid, iscompleted, parentId)} id={parentId}>
                    {/* {
                        this.state.optionSub &&
                        <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '75px', left: '132px' }}>
                            {
                                this.props.loads.map((load, i) => {
                                    if (load.loadNum != loadNum) {
                                        return (<li>
                                            <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                        </li>)
                                    }
                                })
                            }
                        </ul>
                    } */}
                    {this.state.optionMenu &&
                        <ul className="menu-option">
                            {
                                !this.props.isCompleted &&
                                <li>
                                    <span style={{ color: 'red' }} onClick={() => this.handleDelete("delete-jump" + jumpId)}>Delete</span>
                                </li>
                            }

                            <NestedFunJumpMenu
                                txt={"Copy"}
                                loadNum={this.props.loadNum}
                                loads={loadsStore.getActiveLoadsForDisplay()}
                                handleCopyClick={this.handleCopyClick}
                                handleCopyPasteClick={this.handleCopyPasteClick}
                                id={"copy-funJump-menu"}
                            />
                            <NestedFunJumpMenu
                                txt={"Move"}
                                loadNum={this.props.loadNum}
                                loads={loadsStore.getActiveLoadsForDisplay()}
                                handleCopyClick={this.handleCutClick}
                                handleCopyPasteClick={this.handleCopyPasteClick}
                                id={"move-funJump-menu"}
                            />
                            {/* <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
                                <span onClick={() => this.handleCopyClick(funJump, loadNum, -1000)} onMouseOver={() => { setTimeout(() => { this.handleCopyClick(funJump, loadNum, -1000) }, 500) }}>Copy</span>
                                {
                                    this.state.copyOptionSub &&
                                    <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
                                        {
                                            this.props.loads.map((load, idx) => {
                                                if (load.loadNum != loadNum) {
                                                    return (<li key={idx}>
                                                        <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                    </li>)
                                                }
                                            })
                                        }
                                    </ul>
                                }
                            </li>
                            {this.props.isCompleted == false && <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                                <span style={{ color: 'red' }} onClick={() => this.handleCutClick(funJump, loadNum, uid, jumpId, timeRemaining)} onMouseOver={() => { setTimeout(() => { this.handleCutClick(funJump, loadNum, uid, jumpId, timeRemaining) }, 500) }}>Move</span>
                                {
                                    this.state.cutOptionSub &&
                                    <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                                        {
                                            this.props.loads.map((load, idx) => {
                                                if (load.loadNum != loadNum) {
                                                    return (<li key={idx}>
                                                        <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                    </li>)
                                                }
                                            })
                                        }
                                    </ul>
                                }
                            </li>} */}
                        </ul>
                    }
                    <Card className="jumpcard">
                        {funJump.teamName ?
                            <CardHeader className="fun-card-header" ><strong>{funJump.teamName}-{funJump.teamType}</strong></CardHeader>
                            : null
                        }
                        <CardBody style={{ padding: '0px' }}>
                            <div className='row'>
                                {!this.props.isCompleted && <CancelJump loadNum={loadNum} jumpId={jumpId} loadNum={loadNum} jumpType={"funJump"} />}
                                <div className={settingsMoreThan4 ? "funjumptype custom-col" : "funjumptype col-3"} style={{ paddingRight: '2px', textAlign: 'center' }} style={{ pointerEvents: IsEventEnable }}>
                                    <EditableJumpType loadNum={loadNum} jumpId={jumpId} jumpType={funJump.jumpType} funJump={funJump} />
                                    <EditableAltitude isToday={this.props.isToday} loadId={this.props.loadId} funJump={funJump} altitude={funJump.altitude} isCompleted={this.props.isCompleted} loadNum={loadNum} jumpId={jumpId} jumpType={funJump.jumpType} />
                                </div>
                                <div className={settingsMoreThan4 ? "cardmiddle jumpers-container" : "cardmiddle col-9"} style={{ pointerEvents: IsEventEnable }}>
                                    <RenderJumperTarget timeRemaining={timeRemaining} load={this.props.load} funJump={funJump} loadNum={loadNum} jumpId={jumpId} disabled={disabled} isClosed={isClosed} isDragging={isDragging} loadsToShow={loadsToShow} fontSize={fontSize} columnsPerGroup={columnsPerGroup} />
                                    {loadsStore.displayOnly ? null : <div className="right-menu" onClick={this.toggleOptions}>
                                        <span>
                                            <i className="fa fa-ellipsis-v"></i>
                                        </span>
                                    </div>
                                    }
                                </div>
                                {/* <Col xs="12" md="2" lg="1" className="jumpClose" style={{ pointerEvents: IsEventEnable }}>
                                    <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"funJump"} />
                                </Col> */}
                            </div>
                        </CardBody>
                        {funJump.note && window.ENV.tenant ==="montereybay"?
                            <CardFooter className="fun-card-footer" >{funJump.note}</CardFooter> : null}
                    </Card>
                </div>
            </div>
        )
    }
}


export default DragSource(Types.ITEM, itemSource, collect)(RenderFunJump)
